<sw-modal
    class="topdata-convert-customer-modal"
    :title="$tc('TopdataContactLoginSW6.admin.convertCustomerModalTitle')"
    variant="default"
    @modal-close="onClose"
>
    <div class="topdata-convert-customer-modal__body">
        <p class="topdata-convert-customer-modal__description">
            {{ $tc('TopdataContactLoginSW6.admin.convertCustomerModalDesc') }}
        </p>

        <sw-field
            v-model="sourceCustomerNumber"
            type="text"
            required
            :label="$tc('TopdataContactLoginSW6.admin.convertCustomerSourceLabel')"
            :placeholder="$tc('TopdataContactLoginSW6.admin.convertCustomerSourcePlaceholder')"
        />

        <sw-field
            v-model="targetCustomerNumber"
            type="text"
            required
            :label="$tc('TopdataContactLoginSW6.admin.convertCustomerTargetLabel')"
            :placeholder="$tc('TopdataContactLoginSW6.admin.convertCustomerTargetPlaceholder')"
        />

        <sw-field
            v-model="deleteContacts"
            type="switch"
            bordered
            :label="$tc('TopdataContactLoginSW6.admin.convertCustomerDeleteContactsLabel')"
            :helpText="$tc('TopdataContactLoginSW6.admin.convertCustomerDeleteContactsHelpText')"
        />
    </div>

    <template #modal-footer>
        <sw-button
            size="small"
            :disabled="isLoading"
            @click="onClose"
        >
            {{ $tc('global.default.cancel') }}
        </sw-button>
        <sw-button
            variant="primary"
            size="small"
            :isLoading="isLoading"
            :disabled="!isValid"
            @click="onConfirm"
        >
            {{ $tc('TopdataContactLoginSW6.admin.convertCustomerConfirmBtn') }}
        </sw-button>
    </template>
</sw-modal>
